<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <ModelTitle title="New Price Tier" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              autofocus
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="PriceTier.name"
              label="Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="PriceTier.discountType"
              :items="[
                { text: 'Percentage', value: 'percentage' },
                { text: 'Fixed', value: 'fixed' },
              ]"
              item-text="text"
              item-value="value"
              label="Discount Type"
              hide-details
              outlined
              dense
            ></v-select>
          </v-col>

          <v-col cols="6" v-if="PriceTier.discountType === 'percentage'">
            <v-text-field
              v-model="PriceTier.rate"
              label="Percentage Value"
              type="number"
              :min="0"
              :max="100"
              outlined
              dense
              hide-details="auto"
              :error-messages="percentageErrors"
            />
          </v-col>
        </v-row>
        <div v-if="PriceTier.discountType === 'fixed'">
          <v-divider class="my-4"></v-divider>
         <div class="text-center">After you save the tier name, you can edit it to set or update the prices.</div>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PriceTierService from "../service.js";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
import Create from "@/modules/Customer/CustomerPrice/components/Create.vue";
import productService from "@/modules/Product/service";

export default {
  name: "create-PriceTier",
  props: {
    createDialog: {
      default: false,
    },
  },
  data() {
    return {
      Products: [],
      phoneSearch: null,
      selectedProduct: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "Product.name",
          sortable: true,
        },
        {
          text: "Price",
          align: "left",
          value: "Product.price",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      loading: false,
      showCustomerPriceDialog: false,
      dialog: false,
      PriceTier: {
        name: null,
        discountType: "percentage",
        rate: null,
      },
      selectedValue: {
        price: 0,
        name: null,
        ProductId: null,
      },
      customPrices: [],
      products: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    PriceTier: {
      name: { required },
    },
    selectedValue: {
      price: {
        required,
      },
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
    phoneSearch(val) {
      if (val && val.length === 1) {
        this.getProduct();
      }
    },
    selectedProduct(val) {
      if (val) {
        this.selectedValue.ProductId = val.id;
        this.selectedValue.price = val.price;
        this.selectedValue.name = val.name;
      }
    },
  },
  computed: {
    percentageErrors() {
      const value = this.PriceTier.rate;
      const errors = [];
      if (value === null || value === "") return errors;
      if (isNaN(value)) errors.push("Must be a number");
      else if (value < 0) errors.push("Cannot be less than 0%");
      else if (value > 100) errors.push("Cannot be more than 100%");
      return errors;
    },
    priceErrors() {
      const errors = [];
      if (!this.$v.selectedValue.price.$dirty) return errors;
      if (!this.$v.selectedValue.price.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.PriceTier.name.$dirty) return errors;
      if (!this.$v.PriceTier.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
  },
  components: {
    Create,
  },

  methods: {
    getProduct() {
      this.loading = true;
      return productService.getAll().then((result) => {
        this.Products = result.data;
        this.loading = false;
      });
    },
    deletePrice(item) {
      this.customPrices = this.customPrices.filter((p) => p !== item);
    },
    addProduct() {
      if (this.selectedValue) {
        const alreadyExists = this.customPrices.some(
          (p) => p.ProductId === this.selectedValue.ProductId
        );
        if (alreadyExists) {
          const productName =
            this.products.find((p) => p.id === this.selectedValue.ProductId)
              ?.name || "This product";
          this.$swal.fire({
            icon: "warning",
            title: `${productName} is already in the list`,
            toast: true,
            position: "top-end",
            timer: 3000,
            showConfirmButton: false,
          });
          return;
        }
        this.customPrices.push(this.selectedValue);
        this.emptyEntryBar();
        // this.$nextTick(() => {
        //   this.$refs.productSearch?.focus(); // focus on autocomplete
        // });
        setTimeout(() => {
          this.$refs.productSearch?.focus(); // blur the autocomplete
        }, 100);
      }
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    emptyEntryBar() {
      this.selectedValue = {
        price: 0,
        name: null,
        ProductId: null,
      };
      this.selectedProduct = null;
      this.phoneSearch = null;
      this.$v.selectedValue.$reset();
    },
    empty() {
      this.PriceTier = {
        name: null,
        discountType: "percentage",
        rate: null,
      };
      this.customPrices = [];
      this.$v.$reset();
    },

    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (
          this.PriceTier.discountType === "percentage" &&
          (this.PriceTier.rate === null || this.PriceTier.rate === "")
        ) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title:
                "Percentage Value is required for Percentage discount type.",
            });
          this.loading = false;
          return;
        }
        // if (
        //   this.PriceTier.discountType === "fixed" &&
        //   (!this.customPrices || this.customPrices.length === 0)
        // ) {
        //   this.$swal
        //     .mixin({
        //       toast: true,
        //       position: "top-end",
        //       showConfirmButton: false,
        //       timer: 3000,
        //     })
        //     .fire({
        //       icon: "error",
        //       title:
        //         "At least one product with price is required for Fixed discount type.",
        //     });
        //   this.loading = false;
        //   return;
        // }
        this.loading = true;
        this.PriceTier.name =
          this.PriceTier.name.charAt(0).toUpperCase() +
          this.PriceTier.name.slice(1);

        const payload = {
          ...this.PriceTier,
          customPrices:
            this.PriceTier.discountType === "fixed" ? this.customPrices : [],
        };

        console.log("payload", payload);
        return PriceTierService.create(payload)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "PriceTier is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
